'use strict';

/* eslint no-undef: "off" */
/**
 * cms index app
 */
define('sideMenu',['bottomSheet', 'svgIcon', 'getCityListApi', 'changeCityApi', 'GAReport', 'util', 'appStorage', 'busEvent'], function (bottomSheet, svgIcon, getCityListApi, changeCityApi, GAReport, Util, appStorage, busEvent) {
  return {
    template: '\n      <div class="in-mask xp-side-menu-mask" @click="hideMenuPanel">\n        <div class="xp-side-menu" @click.stop>\n          <div class="xp-side-menu-header">\n            <img class="xp-side-menu-logo" :src="logo.url">\n            <button type="button" class="xp-side-menu-close" @click="hideMenuPanel">\n              <svg-icon type="close"></svg-icon>\n            </button>\n          </div>\n\n          <div class="xp-side-menu-body">\n            <div class="xp-menu-card">\n              <a class="xp-menu-row" v-for="link in staticLinks" :href="link.url" @click="onAboutBtnClicked(link.text, $event)">\n                <span v-html="link.text"></span>\n                <svg-icon type="arrowRight"></svg-icon>\n              </a>\n            </div>\n\n            <div class="xp-menu-card xp-menu-option-card">\n              <button type="button" class="xp-menu-row" @click="openSheet(\'country\')">\n                <span>Country</span>\n                <span class="xp-menu-row-value">\n                  <img v-if="currentCountry.image" :src="currentCountry.image">\n                  <span v-text="currentCountry.title"></span>\n                  <svg-icon type="arrowRight"></svg-icon>\n                </span>\n              </button>\n              <button type="button" class="xp-menu-row" @click="openCitySheet">\n                <span>City</span>\n                <span class="xp-menu-row-value">\n                  <span v-text="currentCityName"></span>\n                  <svg-icon type="arrowRight"></svg-icon>\n                </span>\n              </button>\n              <button type="button" class="xp-menu-row" @click="openSheet(\'language\')">\n                <span>Language</span>\n                <span class="xp-menu-row-value">\n                  <span v-text="currentLanguage.name"></span>\n                  <svg-icon type="arrowRight"></svg-icon>\n                </span>\n              </button>\n            </div>\n\n            <div class="xp-menu-service" v-html="serviceHtml"></div>\n          </div>\n\n          <bottom-sheet\n            :visible="activeSheet === \'country\'"\n            title="Country or Region"\n            @close="closeSheet"\n            @confirm="confirmCountry">\n            <div class="xp-select-list">\n              <button\n                type="button"\n                class="xp-select-row"\n                :class="{active: isCountrySelected(country)}"\n                v-for="country in countries"\n                @click="selectCountry(country)">\n                <span class="xp-select-row-label">\n                  <img v-if="country.image" :src="country.image">\n                  <span v-html="country.title"></span>\n                </span>\n                <svg-icon v-if="isCountrySelected(country)" type="check"></svg-icon>\n              </button>\n            </div>\n          </bottom-sheet>\n\n          <bottom-sheet\n            :visible="activeSheet === \'city\'"\n            title="City"\n            sheet-class="xp-bottom-sheet-tall xp-city-sheet"\n            @close="closeSheet"\n            @confirm="confirmCity">\n            <template slot="header">\n              <div class="xp-city-tabs">\n                <button type="button" :class="{active: cityStep === \'area\'}" @click="cityStep = \'area\'" v-text="cityAreaTabText"></button>\n                <button type="button" :class="{active: cityStep === \'city\'}" @click="cityStep = \'city\'" v-text="cityCityTabText"></button>\n              </div>\n            </template>\n            <div class="xp-city-select-wrap">\n              <div class="xp-select-list xp-city-list" ref="cityListScroller">\n                <div class="xp-city-group" v-for="group in cityGroups">\n                  <p class="xp-city-letter" :data-city-letter="group.letter" v-text="group.letter"></p>\n                  <button\n                    type="button"\n                    class="xp-select-row"\n                    :class="{active: isCityOptionSelected(item)}"\n                    v-for="item in group.items"\n                    @click="selectCityOption(item)">\n                    <span class="xp-select-row-label" v-text="item.name || item.text"></span>\n                    <svg-icon v-if="isCityOptionSelected(item)" type="check"></svg-icon>\n                  </button>\n                </div>\n              </div>\n              <div class="xp-city-index" v-if="cityGroups.length > 1">\n                <button type="button" v-for="group in cityGroups" @click="scrollToCityLetter(group.letter)" v-text="group.letter"></button>\n              </div>\n            </div>\n          </bottom-sheet>\n\n          <bottom-sheet\n            :visible="activeSheet === \'language\'"\n            title="Language"\n            @close="closeSheet"\n            @confirm="confirmLanguage">\n            <div class="xp-select-list">\n              <button\n                type="button"\n                class="xp-select-row"\n                :class="{active: selectedLanguage === link}"\n                v-for="link in stores"\n                @click="selectLanguage(link)">\n                <span class="xp-select-row-label" v-text="link.name"></span>\n                <svg-icon v-if="selectedLanguage === link" type="check"></svg-icon>\n              </button>\n            </div>\n          </bottom-sheet>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        stores: window.commonDataJSON.stores || [],
        logo: window.commonDataJSON.logo || {},
        countries: window.commonDataJSON.xpark_webs || [],
        serviceHtml: window.commonDataJSON.mobile_service,
        activeSheet: '',
        selectedCountry: null,
        selectedLanguage: null,
        areaList: [],
        curArea: null,
        curCity: null,
        draftArea: null,
        draftCity: null,
        cityStep: 'area',
        staticLinks: [],
        i18n: {
          aboutUs: 'About Us',
          deliveryInfo: 'Delivery Info',
          privacyPolicy: 'Privacy Policy',
          termsOfUse: 'Terms Of Use',
          FAQ: 'FAQ',
          orderSearch: 'Order Search'
        }
      };
    },

    components: {
      bottomSheet: bottomSheet,
      svgIcon: svgIcon
    },
    computed: {
      currentCountry: function currentCountry() {
        return this.selectedCountry || this.findSelectedCountry() || {
          title: 'Nigeria',
          image: ''
        };
      },
      currentLanguage: function currentLanguage() {
        return this.selectedLanguage || this.findSelectedLanguage() || {
          name: 'English',
          url: ''
        };
      },
      currentCityName: function currentCityName() {
        return this.curCity && (this.curCity.name || this.curCity.text) || 'IKEJA';
      },
      draftAreaName: function draftAreaName() {
        return this.draftArea && (this.draftArea.name || this.draftArea.text) || 'Area';
      },
      draftCityName: function draftCityName() {
        return this.draftCity && (this.draftCity.name || this.draftCity.text) || 'City';
      },
      cityAreaTabText: function cityAreaTabText() {
        if (this.cityStep === 'city') {
          return this.draftAreaName;
        }
        return 'Select Region';
      },
      cityCityTabText: function cityCityTabText() {
        return 'Select City';
      },
      cityOptions: function cityOptions() {
        if (this.cityStep === 'city') {
          return this.getChildren(this.draftArea);
        }
        return this.areaList;
      },
      cityGroups: function cityGroups() {
        return this.groupByLetter(this.cityOptions);
      }
    },
    created: function created() {
      this.staticLinks = [{
        text: this.i18n.aboutUs,
        url: '/about-us'
      }, {
        text: this.i18n.deliveryInfo,
        url: '/delivery-information'
      }, {
        text: this.i18n.privacyPolicy,
        url: '/privacy-policy'
      }, {
        text: this.i18n.termsOfUse,
        url: '/terms-of-use'
      }, {
        text: this.i18n.orderSearch,
        url: '/searchorder'
      }, {
        text: this.i18n.FAQ,
        url: '/faq'
      }];
      this.selectedCountry = this.findSelectedCountry();
      this.selectedLanguage = this.findSelectedLanguage();
    },
    mounted: function mounted() {
      var _this = this;

      this.getCityList();
      busEvent.$on('openSideMenuChangeCity', function () {
        _this.openCitySheet();
      });
    },

    methods: {
      hideMenuPanel: function hideMenuPanel() {
        this.closeSheet();
        $('body').removeClass('in-menu-open');
      },
      openSheet: function openSheet(sheet) {
        this.activeSheet = sheet;
      },
      closeSheet: function closeSheet() {
        this.activeSheet = '';
      },
      openCitySheet: function openCitySheet() {
        this.draftArea = this.curArea || this.areaList[0] || null;
        this.draftCity = this.curCity || this.getDefaultCity(this.draftArea);
        this.cityStep = 'area';
        this.openSheet('city');
      },
      getCityList: function getCityList() {
        var _this2 = this;

        getCityListApi().then(function (resData) {
          _this2.areaList = Array.isArray(resData) ? resData : [];
          _this2.filterCurCity();
        });
      },
      filterCurCity: function filterCurCity() {
        var _this3 = this;

        var defaultArea = this.areaList[0] || null;
        var defaultCity = this.getDefaultCity(defaultArea);

        this.areaList.forEach(function (area) {
          if (_this3.isDefault(area)) {
            defaultArea = area;
            defaultCity = _this3.getDefaultCity(area);
          }
        });

        this.curArea = defaultArea;
        this.curCity = defaultCity;
        this.draftArea = defaultArea;
        this.draftCity = defaultCity;

        this.$nextTick(function () {
          var isPosition = appStorage.get('isAutoPosition');
          console.log('isPosition:', isPosition, 'need to Position:', !isPosition || new Date().getTime() >= Number(isPosition) + 7 * 24 * 60 * 60 * 1000);
          if (!isPosition || new Date().getTime() >= Number(isPosition) + 7 * 24 * 60 * 60 * 1000) {
            _this3.resetCruCity();
          }
        });
      },
      resetCruCity: function resetCruCity() {
        var _this4 = this;

        Util.getPositionWithGoogle().then(function (res) {
          if (res && res.location && res.location.lat && res.location.lng) {
            Util.getPositionCityName(res.location.lat + ',' + res.location.lng).then(function (response) {
              // 记录定位时间
              appStorage.set('isAutoPosition', new Date().getTime());
              if (response && response.success && response.city && response.city.id) {
                // Reset
                changeCityApi({ cityId: response.city.id }).then(function (resData) {
                  _this4.curArea = response.area;
                  _this4.curCity = response.city;
                  _this4.draftArea = response.area;
                  _this4.draftCity = response.city;
                  console.log('Reset current location:', response.city);
                  busEvent.$emit("resetPosition");
                });
              }
            });
          }
        });
      },
      getDefaultCity: function getDefaultCity(area) {
        var _this5 = this;

        var children = this.getChildren(area);
        var defaultCity = children[0] || null;

        children.forEach(function (city) {
          if (_this5.isDefault(city)) {
            defaultCity = city;
          }
        });

        return defaultCity;
      },
      getChildren: function getChildren(area) {
        return area && Array.isArray(area.children) ? area.children : [];
      },
      isDefault: function isDefault(item) {
        return item && (item.is_default === true || item.is_default === 1 || item.is_default === '1' || item.isChecked === true || item.isChecked === 1);
      },
      findSelectedCountry: function findSelectedCountry() {
        return this.countries.filter(function (country) {
          return country.isCurrent;
        })[0] || this.countries[0] || null;
      },
      findSelectedLanguage: function findSelectedLanguage() {
        return this.stores.filter(function (store) {
          return store.choosed;
        })[0] || this.stores[0] || null;
      },
      selectCountry: function selectCountry(country) {
        this.selectedCountry = country;
      },
      isCountrySelected: function isCountrySelected(country) {
        return this.selectedCountry === country || !this.selectedCountry && country.isCurrent;
      },
      confirmCountry: function confirmCountry() {
        if (this.selectedCountry) {
          new GAReport().customerClick({
            eventAction: 'COUNTRY_CHANGE_TO_' + this.selectedCountry.title,
            eventCategory: 'COUNTRY_CHANGE_#VERSION#'
          });

          if (this.selectedCountry.href && !this.selectedCountry.isCurrent) {
            window.location.href = this.selectedCountry.href;
            return;
          }
        }
        this.closeSheet();
      },
      selectCityOption: function selectCityOption(item) {
        var _this6 = this;

        if (this.cityStep === 'area') {
          this.draftArea = item;
          this.draftCity = this.getDefaultCity(item);
          this.cityStep = 'city';
          this.$nextTick(function () {
            _this6.resetCityScroll();
          });
          return;
        }

        this.draftCity = item;
      },
      isCityOptionSelected: function isCityOptionSelected(item) {
        if (this.cityStep === 'area') {
          return this.draftArea === item;
        }
        return this.draftCity === item;
      },
      confirmCity: function confirmCity() {
        var _this7 = this;

        if (!this.draftCity || !this.draftCity.id) {
          this.closeSheet();
          return;
        }

        changeCityApi({ cityId: this.draftCity.id }).then(function () {
          _this7.curArea = _this7.draftArea;
          _this7.curCity = _this7.draftCity;
          _this7.closeSheet();
          window.location.reload();
        });

        if (this.draftCity.name) {
          new GAReport().customerClick({
            eventAction: 'TOP_CHANGE_SHIP_CITY_TO_' + this.draftCity.name,
            eventCategory: 'CHANGE_SHIP_CITY_#VERSION#'
          });
        }
      },
      selectLanguage: function selectLanguage(language) {
        this.selectedLanguage = language;
      },
      confirmLanguage: function confirmLanguage() {
        if (this.selectedLanguage) {
          new GAReport().customerClick({
            eventAction: 'TOP_CHANGE_LANGUAGE_TO_' + this.selectedLanguage.name,
            eventCategory: 'CHANGE_LANGUAGE_#VERSION#'
          });

          if (this.selectedLanguage.url && !this.selectedLanguage.choosed) {
            window.location.href = this.selectedLanguage.url;
            return;
          }
        }
        this.closeSheet();
      },
      groupByLetter: function groupByLetter(list) {
        var _this8 = this;

        var groups = [];
        var groupMap = {};

        list.forEach(function (item) {
          var letter = _this8.getItemLetter(item);

          if (!groupMap[letter]) {
            groupMap[letter] = {
              letter: letter,
              items: []
            };
            groups.push(groupMap[letter]);
          }

          groupMap[letter].items.push(item);
        });

        return groups.sort(function (a, b) {
          return a.letter.localeCompare(b.letter);
        });
      },
      getItemLetter: function getItemLetter(item) {
        var letter = item && (item.letter || item.first_letter || item.initial || item.index);
        var name = item && (item.name || item.text || '');

        if (!letter && name) {
          letter = name.charAt(0);
        }

        letter = String(letter || '#').charAt(0).toUpperCase();
        return (/^[A-Z0-9]$/.test(letter) ? letter : '#'
        );
      },
      scrollToCityLetter: function scrollToCityLetter(letter) {
        var scroller = this.$refs.cityListScroller;
        var target = this.$el.querySelector('[data-city-letter="' + letter + '"]');

        if (scroller && target) {
          scroller.scrollTop = target.offsetTop - scroller.offsetTop;
        }
      },
      resetCityScroll: function resetCityScroll() {
        if (this.$refs.cityListScroller) {
          this.$refs.cityListScroller.scrollTop = 0;
        }
      },
      onAboutBtnClicked: function onAboutBtnClicked(text, e) {
        new GAReport().customerClick({
          eventAction: 'TOP_FOOTER_CLICK_' + text,
          eventCategory: 'TOP_FOOTER_CLICK_#VERSION#'
        });

        e.stopPropagation();
      }
    }
  };
});
